// Global
import React from 'react';

// Local
import { Content } from '@generated/Content/EmbeddedVideo.model';
import { EmbeddedVideoMain } from './EmbeddedVideo';
import { Data } from '@generated/Foundation.GMI.model';
import { useSitecoreContext } from 'lib/hooks/useSitecoreContext';
import { EditingHelpText } from 'components/helpers/Editing/EditingHelpText';

type EmbeddedVideoProps = Content.EmbeddedVideo.EmbeddedVideo_Component & {
  fields: {
    videoItem: Data.Content.Video;
  };
};

export const Default = (props: EmbeddedVideoProps) => {
  /*
   * Rendering
   */

  const { sitecoreContext } = useSitecoreContext();
  const videoTranscriptFileUrl =
    sitecoreContext.videoTranscriptUrls?.[props.fields.videoItem?.fields?.videoId?.value ?? ''] ??
    '';

  if (!props.fields) {
    return <></>;
  }

  const videoItem = props.fields.videoItem;

  if (!videoItem) {
    return (
      <EditingHelpText priority="warning" componentName="Embedded Video">
        No video item selected.
      </EditingHelpText>
    );
  }
  if (!videoItem.fields?.videoId && !videoItem.fields?.videoURL) {
    return (
      <EditingHelpText priority="warning" componentName="Embedded Video">
        Ensure that a video is selected and not a video folder.
      </EditingHelpText>
    );
  }
  if (!videoItem.fields?.videoId?.value && !videoItem.fields?.videoURL?.value) {
    return (
      <EditingHelpText priority="warning" componentName="Embedded Video">
        Selected video is missing a video ID or video URL.
      </EditingHelpText>
    );
  }
  return (
    <EmbeddedVideoMain
      videoId={videoItem.fields?.videoId?.value ?? ''}
      videoTitle={videoItem.fields?.videoHeadline?.value ?? ''}
      videoThumbnailUrl={videoItem.fields?.videoThumbnail?.value?.src ?? ''}
      videoWithAudioDescriptionURL={videoItem.fields?.videoWithAudioDescriptionURL?.value ?? ''}
      videoTranscriptFileUrl={videoTranscriptFileUrl}
      isPortrait={false}
      videoUrl={videoItem.fields?.videoURL?.value ?? ''}
      videoType={videoItem.fields?.videoType?.value ?? ''}
      noPadding={props.fields?.noPadding?.value}
    />
  );
};
